import Invoice from './views/Invoice.vue'
import InvoiceDetails from './views/InvoiceDetails.vue'
import DeliveryForm from './views/DeliveryForm.vue'
import DeliveryFormDetails from './views/DeliveryFormDetails.vue'

const route = [
  {
    path: '/factures',
    name: 'invoice',
    component: Invoice,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Mes factures',
      lang_code: "my_invoices", 
      role: ['A','R','C','I'],
      customer_required: true,
      order: 5
    }
  },
  {
    path: '/bon-de-livraison',
    name: 'delivery',
    component: DeliveryForm,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Mes bons de livraison',
      lang_code: "my_delivery_notes",
      role: ['A','R','C','I'],
      customer_required: true,
      order: 4
    }
  },
  {
    path: '/detail-facture/:invoice_id',
    name: 'invoicedetails',
    component: InvoiceDetails,
    props: {
      default: true
    },
    meta: {
      layout: 'default',
      auth: true,
      menu: false,
      role: ['A','R','C','I']
    }
  },
  {
    path: '/detail-bon-de-livraison/:delivery_form_id',
    name: 'deliveryformdetails',
    component: DeliveryFormDetails,
    props: {
      default: true
    },
    meta: {
      layout: 'default',
      auth: true,
      menu: false,
      role: ['A','R','C','I'],
    }
  },
]

export default route